import watchInvoices from './invoices'

export default watchInvoices
